import { render, staticRenderFns } from "./ProjectGallary.vue?vue&type=template&id=3d959164&scoped=true&"
import script from "./ProjectGallary.vue?vue&type=script&lang=js&"
export * from "./ProjectGallary.vue?vue&type=script&lang=js&"
import style0 from "./ProjectGallary.vue?vue&type=style&index=0&id=3d959164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d959164",
  null
  
)

export default component.exports